import React from 'react';
export const TrustBar = () => {
  return <section className="bg-[#1a2e1c] py-6 md:py-8" data-id="element-483">
      <div className="container mx-auto px-4 md:px-8" data-id="element-484">
        {/* Compliant row */}
        <div className="flex items-center justify-center gap-6 md:gap-12 mb-5" data-id="element-485">
          <div className="flex items-center gap-2" data-id="element-486">
            <div className="bg-white/95 rounded-md px-3 py-1.5" data-id="element-487">
              <img src="https://cdn.magicpatterns.com/uploads/cu3MDDjCGv6evPcHWpiV4U/Dubai_Land_Department_compliant.png" alt="Dubai Land Department" className="h-8 md:h-9 object-contain" data-id="element-488" />
            </div>
            <span className="text-white/50 text-[10px] md:text-xs font-medium hidden sm:block" data-id="element-489">
              DLD Compliant
            </span>
          </div>
          <div className="w-px h-8 bg-white/10" data-id="element-490"></div>
          <div className="flex items-center gap-2" data-id="element-491">
            <div className="bg-white/95 rounded-md px-3 py-1.5" data-id="element-492">
              <img src="https://cdn.magicpatterns.com/uploads/1xJZhj4hfNVptFz8oMkj5q/rera_1-removebg-preview.png" alt="RERA" className="h-8 md:h-10 object-contain" data-id="element-493" />
            </div>
            <span className="text-white/50 text-[10px] md:text-xs font-medium hidden sm:block" data-id="element-494">
              RERA Registered
            </span>
          </div>
        </div>

        {/* Thin divider */}
        <div className="w-40 mx-auto h-px bg-white/10 mb-5" data-id="element-495"></div>

        {/* Partners row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10" data-id="element-496">
          <img src="https://cdn.magicpatterns.com/uploads/qA5VzJ1ypcC8H2566yfiEa/svgviewer-output_(3).svg" alt="Emaar" className="h-5 md:h-6 object-contain opacity-50" data-id="element-497" />
          <img src="https://cdn.magicpatterns.com/uploads/rc7ZimH8Cw8GfHCLG1LrRj/Sobha-white-Logoneww.png" alt="Sobha" className="h-5 md:h-7 object-contain opacity-50" data-id="element-498" />
          <img src="https://cdn.magicpatterns.com/uploads/5jAG46wYymUPPjX925Z3sH/damac-logo-white.png" alt="Damac" className="h-4 md:h-6 object-contain opacity-50" data-id="element-499" />
          <img src="https://cdn.magicpatterns.com/uploads/fXEGCjPqXSfDHsFhaxrN73/nakheel-white-logo.png.webp" alt="Nakheel" className="h-6 md:h-8 object-contain opacity-50" data-id="element-500" />
          <img src="https://cdn.magicpatterns.com/uploads/fMAaDkRNRDHfa2eVef3FFi/Meraas-Eng-Whiteout-logo.png" alt="Meraas" className="h-5 md:h-7 object-contain opacity-50" data-id="element-501" />
        </div>
      </div>
    </section>;
};